'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = require('preact');

var _functional = require('../../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-unused-vars
var PushComplimentaryModal = function (_Component) {
  (0, _inherits3.default)(PushComplimentaryModal, _Component);

  function PushComplimentaryModal(props) {
    (0, _classCallCheck3.default)(this, PushComplimentaryModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PushComplimentaryModal.__proto__ || Object.getPrototypeOf(PushComplimentaryModal)).call(this, props));

    _this.handleFormSubmit = function (event) {
      _this.setState({ submissionInProgress: true });
    };

    _this.state = {
      complimentaryProducts: {},
      items: [],
      submissionInProgress: false
    };

    _this.complimentaryProductsHandles = _this.props.complimentary.products.split(',');

    _this.complimentaryProductsHandles.forEach(function (productHandle) {
      _this.getComplimentaryProduct(productHandle).then(function (productData) {
        _this.setState({
          complimentaryProducts: [].concat((0, _toConsumableArray3.default)(_this.state.complimentaryProducts), [productData])
        });
      });
    });

    window.addEventListener('cart:updated', function (e) {
      window.cart.getState().then(function (data) {
        return _this.updateCart(data);
      }).catch(function (err) {
        return console.error(err);
      });
    }, false);
    return _this;
  }

  (0, _createClass3.default)(PushComplimentaryModal, [{
    key: 'updateCart',
    value: function updateCart(data) {
      this.setState({
        items: data.items
      });
    }
  }, {
    key: 'getComplimentaryProduct',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(productHandle) {
        var productData;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _functional.fetchProductData)(productHandle);

              case 2:
                productData = _context.sent;
                return _context.abrupt('return', productData);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getComplimentaryProduct(_x) {
        return _ref.apply(this, arguments);
      }

      return getComplimentaryProduct;
    }()
  }, {
    key: 'inCartCount',
    value: function inCartCount(handle) {
      var isInCart = handle ? this.state.items.filter(function (item) {
        return item.handle === handle && Object.keys(item.properties).includes('_complimentary');
      }).length > 0 : 0;

      return isInCart;
    }
  }, {
    key: 'getCartKey',
    value: function getCartKey(handle) {
      if (this.state.items.length > 0) {
        var match = this.state.items.find(function (item) {
          return item.handle === handle && Object.keys(item.properties).includes('_complimentary');
        });

        if (match) {
          return match.key;
        }
      }
    }
  }, {
    key: 'removeItem',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(key) {
        var event;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (key) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return window.cart.removeItem(key);

              case 4:
                event = new Event('cart:removed');
                // Dispatch the event.

                window.dispatchEvent(event);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeItem(_x2) {
        return _ref2.apply(this, arguments);
      }

      return removeItem;
    }()
  }, {
    key: 'closeModal',
    value: function closeModal() {
      (0, _functional.getElement)('[data-modal="complimentary"]').classList.remove('mod-Modal-active');
    }
  }, {
    key: 'render',
    value: function render(props, state, context) {
      var _this2 = this;

      if (Object.keys(this.state.complimentaryProducts).length === 0) {
        return null;
      }
      if (!this.props.complimentary.enable === 'false' && this.props.subtotal > this.props.complimentary.min_price) {
        return null;
      }

      // Ensure the order from the Theme Editor is preserved
      var order = this.complimentaryProductsHandles;
      var productObjects = this.state.complimentaryProducts;
      var orderedProductObjects = order.map(function (key) {
        return productObjects.find(function (obj) {
          return obj.handle === key;
        });
      }).filter(function (obj) {
        return obj !== undefined;
      });

      return (0, _preact.h)(
        'div',
        { 'class': 'mod-Modal', 'data-modal': 'complimentary' },
        (0, _preact.h)(
          'div',
          { 'class': 'mod-Modal_Inner lyt-Container' },
          (0, _preact.h)(
            'div',
            { 'class': 'mod-Modal_Body', 'data-modal-body': true },
            (0, _preact.h)(
              'div',
              { 'class': 'mod-Complimentary_Header' },
              (0, _preact.h)(
                'span',
                { 'class': 'mod-Complimentary_HeaderTitle' },
                props.translations.complimentaryModalTitle
              ),
              (0, _preact.h)(
                'button',
                {
                  type: 'button',
                  'class': 'mod-Modal_Close',
                  onClick: this.closeModal
                },
                (0, _preact.h)(
                  'span',
                  { 'class': 'mod-Modal_CloseTitle util-ScreenReaderOnly' },
                  'Close'
                ),
                (0, _preact.h)('span', { 'class': 'mod-Modal_CloseLine mod-Modal_CloseLine-1' }),
                (0, _preact.h)('span', { 'class': 'mod-Modal_CloseLine mod-Modal_CloseLine-2' })
              )
            ),
            (0, _preact.h)(
              'div',
              { 'class': 'mod-Complimentary_Products' },
              orderedProductObjects.map(function (product) {
                return (0, _preact.h)(
                  'div',
                  { className: 'mod-Complimentary_Product' },
                  (0, _preact.h)(
                    'div',
                    { className: 'mod-Complimentary_ProductImageWrapper' },
                    (0, _preact.h)('img', {
                      className: 'mod-Complimentary_ProductImage',
                      src: product.featured_image,
                      title: product.title
                    })
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'mod-Complimentary_ProductInfo' },
                    (0, _preact.h)(
                      'h4',
                      { className: 'mod-Complimentary_ProductTitle' },
                      product.type !== 'Gift Card' && product.type !== null && (0, _preact.h)(
                        'span',
                        {
                          className: 'mod-Complimentary_ProductType mod-Complimentary_ProductType-' + product.type.toLowerCase()
                        },
                        product.type
                      ),
                      product.title
                    ),
                    (0, _preact.h)(
                      'p',
                      { className: 'mod-Complimentary_ProductPrice' },
                      (0, _preact.h)(
                        'span',
                        { className: 'mod-Complimentary_PriceStrike igComparePrice' },
                        (0, _functional.formatMoney)(product.price)
                      ),
                      (0, _preact.h)(
                        'span',
                        { className: 'mod-Complimentary_ActualPrice igPrice' },
                        (0, _functional.formatMoney)(0)
                      )
                    ),
                    (0, _preact.h)(
                      'form',
                      {
                        className: 'mod-Complimentary_Form js-AddToCart',
                        action: '/cart/add',
                        method: 'post',
                        enctype: 'multipart/form-data',
                        onSubmit: _this2.handleFormSubmit
                      },
                      (0, _preact.h)('input', {
                        type: 'hidden',
                        name: 'tiktok_content_name',
                        value: product.title
                      }),
                      (0, _preact.h)('input', {
                        type: 'hidden',
                        name: 'properties[_complimentary]',
                        value: 'true'
                      }),
                      (0, _preact.h)('input', {
                        type: 'hidden',
                        name: 'properties[_complimentary_max]',
                        value: window.theme.complimentary_max
                      }),
                      (0, _preact.h)('input', {
                        type: 'hidden',
                        name: 'id',
                        value: product.variants[0].id
                      }),
                      (0, _preact.h)('input', { type: 'hidden', name: 'quantity', value: '1' }),
                      (0, _preact.h)(
                        'div',
                        { className: 'mod-Complimentary_Actions' },
                        (0, _preact.h)(
                          'button',
                          {
                            'data-complimentary-action': 'submit',
                            className: 'mod-Complimentary_Action btn-Primary js-AddToCart_Submit ' + (_this2.state.submissionInProgress || !product.available || _this2.complimentaryInCartCount >= _this2.props.complimentary.max ? 'btn-Button-disabled' : ''),
                            type: 'submit',
                            'aria-hidden': _this2.inCartCount(product.handle),
                            onClick: function onClick() {
                              return _this2.setState({ submissionInProgress: true });
                            }
                          },
                          'Add to Bag'
                        ),
                        (0, _preact.h)(
                          'button',
                          {
                            className: 'mod-Complimentary_Action btn-Secondary js-AddToCart_Remove ' + (_this2.state.submissionInProgress || !product.available ? 'btn-Button-disabled' : ''),
                            disabled: !product.available,
                            type: 'button',
                            'aria-hidden': !_this2.inCartCount(product.handle),
                            onClick: function onClick() {
                              _this2.setState({ submissionInProgress: true });
                              _this2.removeItem(_this2.getCartKey(product.handle));
                            }
                          },
                          'Remove Item'
                        )
                      )
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.items !== prevState.items) {
        this.setState({ submissionInProgress: false });
      }
    }
  }, {
    key: 'complimentaryInCartCount',
    get: function get() {
      var complimentaryProductsHandles = this.props.complimentary.products.split(',');
      var isInCart = this.props.complimentary.products ? this.state.items.filter(function (item) {
        return complimentaryProductsHandles.includes(item.handle) && Object.keys(item.properties).includes('_complimentary');
      }).length : 0;

      return isInCart;
    }
  }]);
  return PushComplimentaryModal;
}(_preact.Component);

exports.default = PushComplimentaryModal;